module.exports = __webpack_public_path__ + "media/images/area-badges/renewable-equitable-energy-e445791817f69f00d19447f262fe2b66.svg";